/**
 * As we are using Angular 8 and current version is not supporting optional chaining
 * This helper function will help you to get optional chaining like feature
 * Safely accesses a nested property in an object without throwing an error
 * if any intermediate property is undefined.
 *
 * @param {any} obj - The object to traverse.
 * @param {string[]} keys - An array of keys representing the path to the desired property.
 * @returns {any} - The value at the specified path, or `undefined` if any key is missing.
 *
 * @example
 * const data = { user: { profile: { name: "Alice" } } };
 *
 * const name = deepSafeAccess(data, ["user", "profile", "name"]); // "Alice"
 * const age = deepSafeAccess(data, ["user", "profile", "age"]); // undefined
 */
export function deepSafeAccess(obj: any, keys: string[]): any {
	return keys.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}
